import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, Paper } from '@material-ui/core';

const maxWidth = 660;

const styles = (theme) => ({
  clear: {
    margin: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      width: '100%',
      maxWidth,
      margin: `${theme.spacing(2)}px auto`,
    },
  },
  paper: {
    padding: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      width: '100%',
      maxWidth,
      margin: `${theme.spacing(2)}px auto`,
      padding: theme.spacing(6),
    },
  },

});

const FormSection = ({ children, classes, clear }) => (clear ? (
  <div className={classes.clear}>
    {children}
  </div>
) : (
  <Paper className={classes.paper}>
    {children}
  </Paper>
)
);

FormSection.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.shape({}).isRequired,
  clear: PropTypes.bool,
};

export default withStyles(styles)(FormSection);
